<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card">
          <div class="card-body">
            <div v-if="loading" class="loader-overlay">
              <div class="spinner"></div>
            </div>
            <!-- Header -->
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col mt-4">
                <h4 class="ms-lg-4">Service Payment Configuration</h4>
              </div>
            </div>

            <!-- Service Selection -->
            <div class="row ms-lg-3">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="role" :aria-label="Role"> Services: </llp-label>
                <select
                  id="status"
                  class="form-control select-dropdown"
                  v-model="selectPaymentName"
                  @change="selectedPaymentMethodProrities"
                >
                  <option value="" disabled selected>
                    Select service name
                  </option>
                  <option
                    :value="method.id"
                    :key="method.id"
                    v-for="method in selectPaymentMethod"
                  >
                    {{ method.name }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Loader -->

            <div class="row" v-if="paymentMethods.length > 0">
              <div class="col mt-4">
                <h5 class="ms-lg-4">Payment methods</h5>

                <!-- Checkbox List -->
                <div class="d-flex flex-wrap gap-3 ms-lg-4 mt-2">
                  <div
                    v-for="method in paymentMethods"
                    :key="method.id"
                    class="p-2 d-flex align-items-center"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input me-2"
                      :id="`method-${method.id}`"
                      :value="method.id"
                      v-model="selectedMethods"
                    />
                    <label :for="`method-${method.id}`" class="mb-0">
                      {{ method.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Save Button -->
            <div class="mt-4 ms-lg-4" v-if="paymentMethods.length > 0">
              <button class="btn btn-secondary" @click="savePriorities">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>

  <!-- Toast -->
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";
import { defineComponent } from "vue";

export default defineComponent({
  name: "PaymentPriority",
  data() {
    return {
      selectPaymentMethod: [], // Services list (for dropdown)
      selectPaymentName: "", // Selected service id
      paymentMethods: [], // Available gateways for selected service
      selectedMethods: [], // Checked method IDs
      loading: false,
    };
  },
  mounted() {
    this.fetchingServicePaymentProrityMethods();
  },
  methods: {
    // Save selected methods
    async savePriorities() {
      try {
        this.loading = true;

        const payload = this.paymentMethods.map((method) => ({
          pg_id: method.id,
          service_id: this.selectPaymentName,
          selected: this.selectedMethods.includes(method.id) ? 1 : 0,
        }));

        const response = await NetworkService.post(
          "/store-payment-configurations",
          payload
        );
          this.$refs.toast.show(response.data.message);

        setTimeout(() => {
          this.paymentMethods = [];
          this.selectPaymentName = "";
          this.selectedMethods = [];
        }, 1500);
      } catch (error) {
        this.$refs.toast.show(
          "Unable to save the Service payment configurations",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },

    async fetchingServicePaymentProrityMethods() {
      try {
        const response = await NetworkService.get("/services-list");
        this.selectPaymentMethod = response.services;
      } catch (error) {
        this.$refs.toast.show("Unable to fetch services", "error");
      }
    },

    async selectedPaymentMethodProrities() {
      try {
        const response = await NetworkService.get(
          `/payment-configurations/${this.selectPaymentName}`
        );

        this.paymentMethods = response.data.map((pg) => ({
          id: pg.gateway_id,
          name: pg.gateway_name,
          selected: pg.selected,
        }));
        this.selectedMethods = this.paymentMethods
          .filter((pg) => pg.selected === 1)
          .map((pg) => pg.id);
      } catch (error) {
        this.$refs.toast.show("Unable to fetch payment methods", "error");
      }
    },
  },
});
</script>

<style scoped>
.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ccc;
  border-top: 4px solid #333;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
